<div class="alert" *ngIf="!oneTimeStatus || oneTimeStatus !== oneTimeAlertStatus.Hide">
  <ng-container [ngSwitch]="type">
    <div *ngSwitchCase="alertType.Success" class="alert__container alert__container--success">
      <div class="alert__icon">
        <mat-icon class="icon">check_circle</mat-icon>
      </div>
      <ng-container *ngTemplateOutlet="alertContentTemplate"></ng-container>
    </div>

    <div *ngSwitchCase="alertType.Info" class="alert__container alert__container--info">
      <div class="alert__icon"><mat-icon class="icon">info</mat-icon></div>
      <ng-container *ngTemplateOutlet="alertContentTemplate"></ng-container>
    </div>

    <div *ngSwitchCase="alertType.Warning" class="alert__container alert__container--warning">
      <div class="alert__icon"><mat-icon class="icon">warning</mat-icon> </div>
      <ng-container *ngTemplateOutlet="alertContentTemplate"></ng-container>
    </div>

    <div *ngSwitchCase="alertType.Error" class="alert__container alert__container--error">
      <div class="alert__icon"><mat-icon class="icon">error</mat-icon></div>
      <ng-container *ngTemplateOutlet="alertContentTemplate"></ng-container>
    </div>
  </ng-container>

  <ng-template #alertContentTemplate>
    <div class="alert__body">
      <div class="alert__content paragraph-medium-regular">
        <ng-content select="[alert-content]"></ng-content>
      </div>
      <div class="alert__button">
        <ng-content select="[alert-button]" class="paragraph-medium-regular"></ng-content>
        <button type="button" class="alert__button--text-only paragraph-medium-bold" *ngIf="oneTimeStatus && !showClose"
          (click)="hideOnetimeAlert()">{{
          oneTimeButtonText || 'Do Not Show Again'}}</button>
        <button mat-icon-button type="button" class="alert__button--text-only" *ngIf="showClose" (click)="hideOnetimeAlert()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </ng-template>
</div>